import { portalAPI } from './portalAPI';

const APIMaventaSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Maventa'] }).injectEndpoints({
    endpoints: (builder) => ({
        isMaventaIntegrationEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/maventa/enabled',
            keepUnusedDataFor: 10 * 60,
            providesTags: ['Maventa'],
        }),
    }),
    overrideExisting: false,
});

export const { useIsMaventaIntegrationEnabledQuery } = APIMaventaSlice;
